// extracted by mini-css-extract-plugin
export default {"locker":"locker_locker__sGWBs","icon":"locker_icon__Wl7lv"};